import React, { useState, useEffect } from 'react';

// Hard-coded contact info — single source of truth lives here. If Isaías ever
// changes his WhatsApp number, only this file needs touching.
var WHATSAPP_NUMBER = '525534653762';  // +52 (55) 3465-3762, digits-only for wa.me
var DEFAULT_MESSAGE = 'Hi Isaías! I have a question about JiMendez products.';

function buildHref() {
  return 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(DEFAULT_MESSAGE);
}

// Floating WhatsApp launcher anchored to bottom-right. We don't try to be
// smart about hiding on /admin* — admin already runs at a different visual
// density, and Isaías browsing his own admin won't be confused by his own
// button. If that ever becomes annoying we can read the route here.
function WhatsAppButton() {
  // Small entrance delay so the button feels intentional rather than chrome —
  // also gives the page time to settle before adding a new fixed element.
  var [mounted, setMounted] = useState(false);
  useEffect(function() {
    var t = setTimeout(function() { setMounted(true); }, 800);
    return function() { clearTimeout(t); };
  }, []);

  return (
    <a
      href={buildHref()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
      data-testid="whatsapp-floating-button"
      style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 400ms ease, transform 400ms ease',
      }}
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-lg shadow-black/40 hover:scale-110 transition-transform"
    >
      {/* Inline WhatsApp glyph — keeps us free of any icon-font dependency */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="white"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.16 1.6 5.97L0 24l6.18-1.62A11.93 11.93 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52ZM12 22a9.93 9.93 0 0 1-5.07-1.38l-.36-.21-3.67.96.98-3.58-.24-.37A9.95 9.95 0 0 1 2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Zm5.45-7.55c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.16 8.16 0 0 1-2.4-1.48 9.05 9.05 0 0 1-1.67-2.07c-.17-.3 0-.46.13-.6.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.5-.5-.67-.51l-.57-.01c-.2 0-.52.08-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.1 4.49.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z"/>
      </svg>
    </a>
  );
}

export default WhatsAppButton;
